/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Virtual Key Definitions (@accedo/xdk-virtual-key) 4.2.2
* 
*******************************************************************************/
import addVKey from"./addVKey";const addVKeys=(d,a)=>{new Map(a).forEach(((a,e)=>addVKey(d,e,a)))};export default addVKeys;